import { useAppStore } from '../stores/app-store'

export function WorkspacePanel() {
  const { currentRun } = useAppStore()

  if (!currentRun) return null

  return (
    <div className="card config-panel">
      <div className="card-header">
        <span className="card-title">Workspace</span>
      </div>

      <div className="config-grid">
        <div className="config-item">
          <label>Provider</label>
          <div className="config-readout">{currentRun.workspace.provider}</div>
        </div>

        <div className="config-item">
          <label>Mode</label>
          <div className="config-readout">{currentRun.workspace.executionMode}</div>
        </div>

        <div className="config-item">
          <label>Status</label>
          <div className="config-readout">{currentRun.workspace.status}</div>
        </div>

        <div className="config-item">
          <label>Artifacts</label>
          <div className="config-readout">{currentRun.artifacts.iterationFiles}</div>
        </div>

        {currentRun.workspace.repoFullName && (
          <div className="config-item full-width">
            <label>Target Repo</label>
            <div className="config-readout">{currentRun.workspace.repoFullName}</div>
          </div>
        )}

        {currentRun.workspace.message && (
          <div className="config-item full-width">
            <label>Workspace Note</label>
            <div className="config-readout config-readout-wrap">{currentRun.workspace.message}</div>
          </div>
        )}
      </div>
    </div>
  )
}
